import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { parse } from 'query-string';
import _ from 'lodash';
import Pagination from '@/components/pagination-new/Pagination';
import useScrollToTop from '@/hooks/useScrollToTop';
import useQuery from './useQuery';
import PaginationInformation from '@/components/pagination-new/PaginationInformation';

Partners.propTypes = {
  children: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired
};

export default function Partners(props) {
  const { router, children, site } = props;
  const { location } = router;

  const node = useRef();
  const scrollToTop = useScrollToTop();

  const pageSize = 12;

  const result = useQuery({
    search: _.extend({}, parse(location.search), {
      locationCondition: JSON.stringify({
        address: site.data.zipCode,
        latitude: site.data.latitude,
        longitude: site.data.longitude,
        radius: 50
      })
    }),
    pageSize,
    distance: site?.data,
    site: site
  });

  return (
    <>
      <div ref={node} className="flex flex-wrap gap-4 justify-between items-end">
        <PaginationInformation
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
        />
      </div>
      {children(result)}
      <div className="space-y-4">
        <div className="flex flex-wrap gap-4 items-center justify-between">
          <PaginationInformation
            pageSize={pageSize}
            totalCount={result.meta?.totalCount}
          />
          <Pagination
            pageSize={pageSize}
            totalCount={result.meta?.totalCount}
            onNavigate={() => scrollToTop(node)}
          />
        </div>
      </div>
    </>
  );
}
